import React from 'react';

const FavoriteIcon = () => (
    <svg width="78" height="78" viewBox="0 0 78 78" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M39 78C60.5391 78 78 60.5391 78 39C78 17.4609 60.5391 0 39 0C17.4609 0 0 17.4609 0 39C0 60.5391 17.4609 78 39 78Z"
            fill="#F2F5FA"
        />
        <path d="M28.1 29.8999L24 33.1999C22.6 34.4999 22 35.1999 22 37.1999V43.9999V51.9999" fill="#F2F5FA" />
        <path
            d="M28.1 29.8999L24 33.1999C22.6 34.4999 22 35.1999 22 37.1999V43.9999V51.9999"
            stroke="#404145"
            strokeWidth="2"
            strokeMiterlimit="10"
        />
        <path
            d="M35.6 37.6002C37.9 39.4002 40.5 41.5002 43 44.1002C50.2 36.8002 57.5 33.9002 58.8 27.4002C59.8 22.6002 56.7 17.7002 51.9 17.2002C48.3 16.8002 44.3 18.8002 43 21.9002C41.6 18.8002 37.7 16.8002 34.1 17.2002C29.3 17.7002 26.2 22.7002 27.2 27.4002C27.8 30.2002 28.6998 31.9 30.9998 34"
            fill="#B9C9F7"
        />
        <path
            d="M35.6 37.6002C37.9 39.4002 40.5 41.5002 43 44.1002C50.2 36.8002 57.5 33.9002 58.8 27.4002C59.8 22.6002 56.7 17.7002 51.9 17.2002C48.3 16.8002 44.3 18.8002 43 21.9002C41.6 18.8002 37.7 16.8002 34.1 17.2002C29.3 17.7002 26.2 22.7002 27.2 27.4002C27.8 30.2002 28.6998 31.9 30.9998 34"
            stroke="#404145"
            strokeWidth="2"
            strokeMiterlimit="10"
        />
        <path d="M62 47L58 47" stroke="#404145" strokeWidth="2" strokeMiterlimit="10" />
        <path d="M54 47L50 47" stroke="#404145" strokeWidth="2" strokeMiterlimit="10" />
        <path d="M56 45L56 41" stroke="#404145" strokeWidth="2" strokeMiterlimit="10" />
        <path d="M56 53L56 49" stroke="#404145" strokeWidth="2" strokeMiterlimit="10" />
        <path
            d="M25.7 40C25.7 40 32.2 33.8 34 32C35.8 30.2 38.3 34.3 36.2 37C35.1 38.1 34 39 34 39C34 39.4 34 40.6 34 41C34 44.9 30.4 46 29.8 46"
            fill="#F2F5FA"
        />
        <path
            d="M36 52V48C36 48 39 45.8 39 43V40.3M25.7 40C25.7 40 32.2 33.8 34 32C35.8 30.2 38.3 34.3 36.2 37C35.1 38.1 34 39 34 39C34 39.4 34 40.6 34 41C34 44.9 30.4 46 29.8 46"
            stroke="#404145"
            strokeWidth="2"
            strokeMiterlimit="10"
        />
        <path d="M52 58L49 58" stroke="#404145" strokeWidth="2" strokeMiterlimit="10" />
        <path d="M47 58L44 58" stroke="#404145" strokeWidth="2" strokeMiterlimit="10" />
        <path d="M48 57L48 54" stroke="#404145" strokeWidth="2" strokeMiterlimit="10" />
        <path d="M48 62L48 59" stroke="#404145" strokeWidth="2" strokeMiterlimit="10" />
        <path d="M39 60H19V52H39V60Z" fill="#F2F5FA" stroke="#404145" strokeWidth="2" strokeMiterlimit="10" />
        <path d="M23 56H24" stroke="#404145" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="round" />
    </svg>
);

export default FavoriteIcon;
